import React, { useEffect, useState } from 'react';
import { Card } from '@/components/ui/card';
import api from '@/lib/api';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export default function BarChartWidget({ widget }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
    
    // Auto-refresh a cada 30 segundos
    const interval = setInterval(loadData, 30000);
    return () => clearInterval(interval);
  }, [widget.id]);

  const loadData = async () => {
    try {
      const { data: result } = await api.get(`/dashboards/widgets/${widget.id}/data`);
      setData(result || []);
    } catch (error) {
      console.error('Erro ao carregar dados do widget:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Card className="p-4 h-full flex items-center justify-center">
        <div className="text-slate-400">Carregando...</div>
      </Card>
    );
  }

  return (
    <Card className="p-5 h-full border-slate-200 flex flex-col">
      <h3 className="text-base font-semibold text-slate-900 mb-2">{widget.title}</h3>
      {data.length === 0 ? (
        <div className="text-sm text-slate-400 py-12 text-center">Sem dados</div>
      ) : (
        <div className="flex-1 min-h-0">
          <ResponsiveContainer width="100%" height="100%" minHeight={200}>
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
              <XAxis dataKey="name" tick={{ fontSize: 12 }} />
              <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
              <Tooltip />
              <Bar dataKey="value" fill="#2563EB" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </Card>
  );
}
